import { from, map, switchMap } from "rxjs";
import { logEvent } from "firebase/analytics";
import { AnalyticsEvent } from "./analytics.interface";

function reportAnalyticsEvent<E>(event: AnalyticsEvent<E>) {
  return from(import("../../providers")).pipe(
    switchMap(({ FirebaseProvider }) =>
      from(FirebaseProvider.getInstance().getAnalytics())
    ),
    map((analytics) =>
      logEvent(analytics, String(event.event), { details: event.details })
    )
  );
}

export { reportAnalyticsEvent };
